<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.processName']">
              <a-select v-model="queryParam.formId" allowClear >
                <a-select-option v-for="(model,index) in allProcess" :key="index" :value="model.formId" >
                  {{ model.formName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.businessFormNo']">
              <a-input  v-model="queryParam.businessFormNo" allowClear></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.creater']">
              <a-input  v-model="queryParam.createUserRealname" allowClear></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['eletronicSigned.processNo']">
              <a-input  v-model="queryParam.processNo" allowClear></a-input><!--placeholder="输入流程编号"-->
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="search_reset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
              <!--<a-button type="primary" @click="batchAgree" icon="setting" style="margin-left: 8px" v-if="selectedRowKeys.length>1">{{language['energy.eletronicSigned.bacthCheck']}}</a-button>-->
              <!--<a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>
      <!--<div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>{{language['common.choosed']}}<a style="font-weight: 600">{{selectedRowKeys.length }}</a>{{ language['common.item'] }}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>-->

      <a-table
        ref="table"
        bordered
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <!--rowKey="id"-->
        <!--:rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"-->

        <template slot="processChartLot" slot-scope="text, record, index">
          <div class="anty-img-wrap">
            <a-icon type="cluster" @click="openChart(record)" style="color:#33A1FF"/>
          </div>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" >{{language['eletronicSigned.check']}}</a>
          <a-divider type="vertical" />
          <a  @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <my-todo-modal ref="modalForm" @reSeach="searchQuery" @ok="modalFormOk"></my-todo-modal>
    <comments-modal ref="commentsModal"  @reSeach="searchQuery"></comments-modal>

    <j-modal
      switchFullscreen
      :mask="false"
      :width="1200"
      :title="language['eletronicSigned.processChart']"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :ok-button-props="{ props: { disabled: true } }"
      @cancel="handleCancel"
      :ok-disabled="true"
      :cancelText="language['common.closeButton']">
      <div style="padding: 20px;overflow-x: scroll;">
        <a-steps  size="small">
          <a-step :title="language['bpm.sign.startTaskName']"  status="finish">
            <template slot="description">
              <p style="color:green" slot="title">{{selectedChartData.createUserRealname}}</p>
            </template>
          </a-step>
          <a-step  :title="item.taskName" v-for="(item,index) in chartList" :key="index"
                   :status="item.taskStatus=='Ready'?'process':(item.taskStatus=='Rejected'?'error':(item.taskStatus=='Completed'?'finish':'wait'))" >
            <template slot="description">
              <p slot="title" v-for="(signUser,i) in item.signUsers" :key="i"
                 :style="(selectedChartData.processStatus=='Cancelled')?(signUser.isSign==1?'color:green':''):(signUser.isSign==1?'color:green':(signUser.ready?'color:red':''))" >
                {{signUser.userCodeName}}
              </p>
            </template>
          </a-step>
          <a-step :title="language['bpm.sign.endTaskName']" description="" :status="selectedChartData.processStatus == 'Completed'?'finish':'wait'"/>
        </a-steps>
      </div>
    </j-modal>
  </a-card>
</template>

<script>
  import MyTodoModal from './modules/MyTodoModal'
  import CommentsModal from './modules/CommentsModal'
  import {putAction, getFileAccessHttpUrl,getAction,postAction} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import JSuperQuery from '@/components/jeecg/JSuperQuery'
  import ACol from "ant-design-vue/es/grid/Col";
  import AFormItem from "ant-design-vue/es/form/FormItem";
  import {cancel} from "./auditJS/cancel"
  import { ACCESS_TOKEN,USER_LANGUAGE } from "@/store/mutation-types"

  export default {
    name: "MyTodoList",
    mixins: [JeecgListMixin],
    components: {
      AFormItem,
      ACol,
      MyTodoModal,
      CommentsModal,
      JInput,
      JSuperQuery
    },
    data() {
      return {
        allProcess:[],
        selectedChartData:{},
        chartList:[],
        visible: false,
        confirmLoading: false,
        queryParam: {
          applicationId:this.$store.getters.application.id,
          createUserRealname:'',
          formId:"",
          businessFormNo:"",
          processNo:'',
        },
        url: {
          list: "/sys/bpm/process/todoProcess",
          // list: "/sys/user/list",
        },
        /* 分页参数 */
        ipagination:{
          current: 1,
          pageSize: 10,
          // pageSizeOptions: ['10'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] +" "+ this.$store.getters.language['common.total']+" " + total +" "+ this.$store.getters.language['common.strip']
          },
          showQuickJumper: true,
          showSizeChanger: false,
          total: 0,
          selectedRows:[],
          selectedRowKeys:[],
        },
      }
    },
    created() {
      // this.initAllprocessAndapplication()
      this.initAllprocess()
    },
    computed: {
      language() {
        return this.$store.getters.language;
      },
      columns() {
        if (this.language) {
          return [
            {
              title: this.language['eletronicSigned.processName'],
              align: "center",
              dataIndex: 'processName',
              width: 230,
              sorter: true,
              /*customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },*/
            },
            {
              title: this.language['eletronicSigned.processNo'],
              align: "center",
              dataIndex: 'processNo',
            },
            {
              title: this.language['eletronicSigned.processStatus'],
              align: "center",
              dataIndex: 'processStatus_dictText',
              // scopedSlots: {customRender: 'processStatus'},
            },
            {
              title: this.language['eletronicSigned.businessFormNo'],
              align: "center",
              dataIndex: 'businessFormNo',
              /*customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },*/
            },
            {
              title: this.language['eletronicSigned.taskText'],
              align: "center",
              width: 200,
              dataIndex: 'readyTaskName',
              /*customRender: function (text, r, index) {
                if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                  return r.task_text_local_lang;
                }else{
                  return r.task_text_en;
                }
              },*/
              /*customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },*/
            },
            {
              title: this.language['eletronicSigned.processChart'],
              align: "center",
              dataIndex: 'id',
              scopedSlots: {customRender: "processChartLot"}
            },
            {
              title: this.language['eletronicSigned.creater'],
              align: "center",
              dataIndex: 'createUserRealname'
            },
            {
              title: this.language['eletronicSigned.startTime'],
              align: "center",
              dataIndex: 'startTime'
            },

            /*{
              title: this.language['eletronicSigned.approveResult'],
              align: "center",
              width: 160,
              dataIndex: 'approveResult',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },*/
            /*{
              title: this.language['eletronicSigned.approveName'],
              align: "center",
              width: 160,
              dataIndex: 'approveName',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },*/
            /*{
              title: this.language['eletronicSigned.approveDate'],
              align: "center",
              dataIndex: 'approveDate'
            },*/
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              scopedSlots: {customRender: 'action'},
              align: "center",
              width: 120,
              fixed: "right"
            }

          ]
        }
      }
    },
    methods: {
      handleEdit(record){
        this.$refs.modalForm.title = this.language['eletronicSigned.check'];
        record.setEdit = true;
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.disableSubmit = false;
      },
      search_reset() {
        this.queryParam ={
          applicationId:this.$store.getters.application.id,
          createUserRealname:'',
          formId:"",
          businessFormNo:"",
          processNo:"",
        },
          this.loadData(1);
      },

      /*getAvatarView: function (avatar) {
        return getFileAccessHttpUrl(avatar)
      },*/
      openChart(record) {
        getAction("/sys/bpm/processTask/getVOlistByProcessId",{processId:record.id}).then(res=>{
          if(res.success){
            this.selectedChartData = {...record}
            this.visible = true;
            this.chartList = res.result;
          }
        })
      },
      handleCancel(e) {
        this.visible = false;
      },
      initAllprocess(){
        getAction("/sys/bpm/model/querylist", {applicationId:this.$store.getters.application.id}).then((res) => {
          if (res.success) {
            let list = [];
            res.result.forEach(item=>{
              let map = {};
              map.formId = item.formId;
              map.formName = item.formName;
              list.push(map);
            })
            this.allProcess = list;
          } else {
          }
        })
      },
      /*initAllprocessAndapplication(){
        getAction("/sys/processSigned/pfBpmModel/listWithOutPage", {applicationCode:this.$store.getters.applicationCode}).then((res) => {
          if (res.success) {
            let processlist = [];
            let applicationlist = [];
            let set = [];
            res.result.forEach(item=>{
              let processmap = {};
              processmap.processModelGuid = item.modelGuid;
              if(window.sessionStorage.getItem(USER_LANGUAGE) === "zh_CN" || window.sessionStorage.getItem(USER_LANGUAGE) === "zh_TW"){
                processmap.processModelName = item.modelNameLocalLang;
              }else{
                processmap.processModelName = item.modelNameEn;
              }
              processlist.push(processmap);
              if(set.indexOf(item.applicationCode) === -1){
                let applicationmap = {};
                applicationmap.processApplicationCode = item.applicationCode;
                applicationmap.processApplicationName = item.applicationName;
                applicationlist.push(applicationmap);
                set.push(item.applicationCode);
              }
            })
            this.allProcess = processlist;
            this.allApplication = applicationlist;
          } else {
          }
        })
      },*/
      getCheckboxProps(record){
        console.log("------------"+this.confirmLoading)
        // return { props: { disabled: !(record.process_status == 'InProcess'||record.process_status == 'Started'||record.process_status == 'Restarted') } }
        return { props: { disabled: false } }
      },
      onSelectChange(selectedRowKeys, selectedRows){
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows;
      },
      onClearSelected(){
        this.selectedRowKeys = []
        this.selectedRows = [];
      },
      batchAgree() {
        let that = this
        if(that.selectedRows.length>0){
          that.loading = true;
          let list = [];
          that.selectedRows.forEach(item=>{
            let map = {};
            map.action='Y';
            map.businessFormNo = item.businessFormNo;
            map.reviewerId = that.$store.getters.userInfo.workNo;
            list.push(map);
          })
          postAction("/sys/bpm-signed/runProcessBatch",list).then(res=>{
            if(res.success){
            }else{
              that.$message.warning(res.message);
            }
          }).finally(() => {
            that.loadData(1);
            that.selectedRowKeys = []
            that.selectedRows = [];
            // that.loading = false;
          })

        }
      }
    }

  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>